import { TrafficInfo } from "./TrafficInfo";
import { TrafficInfoProvider } from "./TrafficInfoProvider";

const DEFAULT_TRAFFIC_MEDIUM = "cpc";

export class DefaultTrafficInfoProvider implements TrafficInfoProvider {
	provideInfo(dashSeparatedTrafficSourceInfo?: string): TrafficInfo {
		if (
			dashSeparatedTrafficSourceInfo === undefined ||
			dashSeparatedTrafficSourceInfo.length === 0
		) {
			return new TrafficInfo();
		}

		const splitTrafficSourceInfo = dashSeparatedTrafficSourceInfo.split("-");
		const trafficSourceInfoFirstPart = splitTrafficSourceInfo[0];
		let trafficSource = "";
		let trafficMedium = DEFAULT_TRAFFIC_MEDIUM;
		if (
			trafficSourceInfoFirstPart.includes("msn") ||
			trafficSourceInfoFirstPart.includes("bing")
		) {
			trafficSource = "bing";
		} else if (
			trafficSourceInfoFirstPart.includes("google") ||
			trafficSourceInfoFirstPart.includes("ggrmlct")
		) {
			trafficSource = "google";
		} else if (
			trafficSourceInfoFirstPart.includes("yahoo") ||
			trafficSourceInfoFirstPart.includes("gemppc")
		) {
			trafficSource = "gemini";
		} else if (
			trafficSourceInfoFirstPart === "pg" &&
			splitTrafficSourceInfo.length > 1
		) {
			trafficMedium = "affiliate";
			trafficSource = splitTrafficSourceInfo[1];
		}

		return new TrafficInfo(trafficSource, trafficMedium);
	}
}
